<app-modal-component
  [open]="openModal"
  [labelledBy]="titleId"
  [describedBy]="describedBy"
  [dialogRole]="isDanger ? 'alertdialog' : 'dialog'"
  [closeOnBackdrop]="!loading"
  (dismiss)="onClose.emit()"
>
  <div class="pc" [attr.data-tone]="isDanger ? 'danger' : null">
    <!-- head -->
    <header class="pc__head">
      <h2 class="bk-heading pc__title" [id]="titleId">{{ title }}</h2>
      <button
        type="button"
        class="bk-icon-btn pc__close"
        aria-label="Close"
        (click)="onClose.emit()"
      >
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    <!-- body -->
    <div class="pc__body" [id]="bodyId">
      <ng-content></ng-content>
    </div>

    <!-- what is at stake (optional) -->
    @if (impact) {
    <p class="pc__impact" [id]="impactId">
      <span class="bk-sym pc__impact-icon" aria-hidden="true">{{ impactIcon }}</span>
      <span>{{ impact }}</span>
    </p>
    }
    <div class="pc__impact-slot" [id]="impactSlotId">
      <ng-content select="[impact]"></ng-content>
    </div>

    <!-- actions: the safe choice first, the action last -->
    <div class="pc__actions">
      <button
        type="button"
        class="bk-btn bk-btn--ghost pc__btn"
        [class]="leftButtonCLass"
        cdkFocusInitial
        (click)="onClose.emit()"
      >
        {{ closeLabel }}
      </button>
      <button
        type="button"
        class="bk-btn bk-btn--primary pc__btn pc__action"
        [class]="rightButtonCLass"
        [class.is-danger]="isDanger"
        [class.is-loading]="loading"
        [disabled]="loading || actionDisabled"
        [attr.aria-busy]="loading || null"
        (click)="onButtonClick.emit()"
      >
        @if (loading) {
        <span class="pc__spinner" aria-hidden="true"></span>
        }
        <span>{{ actionLabel }}</span>
      </button>
    </div>
  </div>
</app-modal-component>
